<div class="landing4-builder" [style.fontFamily]="tipografia">
  <div class="builder-container" #builderContainer [class.preview-mode]="!modoEdicion" [class.toolbar-collapsed]="toolbarColapsada" [style.background]="settings.backgroundColor" [style.--mod-gap]="settings.moduleSpacing">
    
    <!-- Barra superior de herramientas -->
    <div class="toolbar" [class.collapsed]="toolbarColapsada">
      <div class="toolbar-left">
        <h3 *ngIf="!toolbarColapsada"><i class="fas fa-magic"></i> Landing Page Builder</h3>
      </div>
      <div class="toolbar-right">
        <div class="global-setting" *ngIf="!toolbarColapsada" style="display:flex; align-items:center; gap:8px;">
          <i class="fas fa-fill-drip" title="Color de fondo"></i>
          <input type="color" [ngModel]="settings.backgroundColor" (ngModelChange)="actualizarBackgroundColor($event)" title="Color de fondo" style="width:32px; height:32px; border:none; background:transparent; cursor:pointer;">
        </div>
        <button class="btn-collapse-toolbar" (click)="toggleToolbar()" title="Colapsar/Expandir barra">
          <i class="fas" [class.fa-chevron-up]="!toolbarColapsada" [class.fa-chevron-down]="toolbarColapsada"></i>
        </button>
        <button class="btn btn-sm btn-outline-primary me-2" (click)="toggleModoEdicion()" *ngIf="!toolbarColapsada">
          <i class="fas" [class.fa-eye]="modoEdicion" [class.fa-edit]="!modoEdicion"></i>
          {{ modoEdicion ? 'Vista Previa' : 'Editar' }}
        </button>
        <button class="btn btn-sm btn-outline-secondary me-2" (click)="guardarConfiguracion()" *ngIf="!toolbarColapsada">
          <i class="fas fa-save"></i> Guardar
        </button>
        <button class="btn btn-sm btn-success" 
                *ngIf="!toolbarColapsada" 
                (click)="finalizarEdicionYGuardar()"
                [disabled]="isGuardandoBuilder || (productId == null && landingPageId == null)"
                title="Terminar edición y guardar">
          <i class="fas" [class.fa-spinner]="isGuardandoBuilder" [class.fa-check]="!isGuardandoBuilder" [class.fa-spin]="isGuardandoBuilder"></i>
          <span class="ms-1">Terminar edición</span>
        </button>
      </div>
    </div>

    <!-- Layout principal -->
    <div class="builder-layout" cdkDropListGroup>
      
      <!-- Panel lateral de componentes (izquierda) -->
      <div class="sidebar-components" [class.collapsed]="sidebarColapsada" *ngIf="modoEdicion">
        <h4 class="sidebar-title">
          <span *ngIf="!sidebarColapsada">Componentes</span>
          <button class="collapse-btn" (click)="toggleSidebar()" title="Colapsar/Expandir">
            <i class="fas" [class.fa-chevron-left]="!sidebarColapsada" [class.fa-chevron-right]="sidebarColapsada"></i>
          </button>
        </h4>
        <div class="components-list" 
             cdkDropList 
             #sidebarList="cdkDropList" 
             [cdkDropListData]="componentesDisponibles" 
             [cdkDropListSortingDisabled]="true"
             cdkDropListAutoScrollDisabled="false">
          <div class="component-item" 
               *ngFor="let comp of componentesDisponibles"
               cdkDrag
               [cdkDragData]="comp.tipo"
               [cdkDragStartDelay]="0">
            <i [class]="comp.icono"></i>
            <span>{{ comp.nombre }}</span>
          </div>
        </div>
      </div>

      <!-- Canvas central -->
      <div class="canvas-container">
           <div class="canvas" 
             cdkDropList
             id="canvas-list"
             #canvasList="cdkDropList"
             [cdkDropListData]="componentesCanvas"
             [cdkDropListAutoScrollStep]="50"
             [style.background]="settings.backgroundColor"
             (cdkDropListDropped)="onDropComponente($event)">
          
          <div class="canvas-empty" *ngIf="componentesCanvas.length === 0 && modoEdicion">
            <i class="fas fa-arrow-left"></i>
            <p>Arrastra componentes aquí para comenzar</p>
          </div>

          <!-- Componentes renderizados -->
          <div class="componente-wrapper" 
               *ngFor="let componente of componentesCanvas; trackBy: trackByComponenteId"
               cdkDrag
               [cdkDragDisabled]="!modoEdicion"
               [cdkDragStartDelay]="0"
               [cdkDragLockAxis]="'y'"
               [class.selected]="componenteSeleccionado?.id === componente.id"
               (click)="modoEdicion && seleccionarComponente(componente)">
            
            <!-- Controles del componente -->
            <div class="componente-controls" *ngIf="modoEdicion">
              <button class="control-btn" (click)="duplicarComponente(componente); $event.stopPropagation()" title="Duplicar">
                <i class="fas fa-copy"></i>
              </button>
              <button class="control-btn delete" (click)="eliminarComponente(componente.id); $event.stopPropagation()" title="Eliminar">
                <i class="fas fa-trash"></i>
              </button>
              <div class="drag-handle" cdkDragHandle>
                <i class="fas fa-grip-vertical"></i>
              </div>
            </div>

            <!-- Renderizado según tipo -->
            <div [ngSwitch]="componente.tipo" class="componente-content">
                            <!-- CONTADOR -->
                            <div *ngSwitchCase="'contador'" 
                                 [style.color]="componente.estilos.color"
                                 [style.fontSize]="componente.estilos.fontSize"
                                 [style.textAlign]="componente.estilos.textAlign"
                                 [style.fontWeight]="componente.estilos.fontWeight"
                                 [style.fontFamily]="componente.estilos.fontFamily"
                                 [style.borderStyle]="componente.estilos.borderStyle || 'none'"
                                 [style.borderWidth]="componente.estilos.borderStyle !== 'none' ? (componente.estilos.borderWidth || '1px') : '0'"
                                 [style.borderColor]="componente.estilos.borderColor || '#cccccc'"
                                 [style.padding]="componente.estilos.borderStyle !== 'none' ? '10px' : '0'">
                              {{ contadorValores[componente.id] || '00:00:00' }}
                            </div>
              
              <!-- TÍTULO -->
              <div *ngSwitchCase="'titulo'" 
                   [style.fontSize]="componente.estilos.fontSize"
                   [style.color]="componente.estilos.color"
                   [style.textAlign]="componente.estilos.textAlign"
                   [style.fontWeight]="componente.estilos.fontWeight"
                   [style.fontFamily]="componente.estilos.fontFamily"
                   [style.borderStyle]="componente.estilos.borderStyle || 'none'"
                   [style.borderWidth]="componente.estilos.borderStyle !== 'none' ? (componente.estilos.borderWidth || '1px') : '0'"
                   [style.borderColor]="componente.estilos.borderColor || '#cccccc'"
                   [style.padding]="componente.estilos.borderStyle !== 'none' ? '10px' : '0'">
                {{ componente.contenido.texto }}
              </div>

              <!-- TEXTO -->
              <div *ngSwitchCase="'texto'"
                   [style.fontSize]="componente.estilos.fontSize"
                   [style.color]="componente.estilos.color"
                   [style.textAlign]="componente.estilos.textAlign"
                   [style.fontFamily]="componente.estilos.fontFamily"
                   [style.borderStyle]="componente.estilos.borderStyle || 'none'"
                   [style.borderWidth]="componente.estilos.borderStyle !== 'none' ? (componente.estilos.borderWidth || '1px') : '0'"
                   [style.borderColor]="componente.estilos.borderColor || '#cccccc'"
                   [style.padding]="componente.estilos.borderStyle !== 'none' ? '10px' : '0'"
                   [innerHTML]="componente.contenido.texto">
              </div>

              <!-- IMAGEN -->
              <div *ngSwitchCase="'imagen'" 
                   [style.textAlign]="componente.estilos.textAlign || 'center'">
                <img [src]="componente.contenido.url" 
                     [alt]="componente.contenido.alt"
                     [style.width]="componente.estilos.width"
                     [style.maxWidth]="componente.estilos.maxWidth"
                     [style.margin]="componente.estilos.margin"
                     [style.borderStyle]="componente.estilos.borderStyle || 'none'"
                     [style.borderWidth]="componente.estilos.borderStyle !== 'none' ? (componente.estilos.borderWidth || '1px') : '0'"
                     [style.borderColor]="componente.estilos.borderColor || '#cccccc'"
                     [style.display]="'inline-block'">
              </div>

              <!-- PERFIL -->
              <div *ngSwitchCase="'perfil'"
                   class="perfil-component sidebar-user"
                   [attr.data-align]="componente.estilos.textAlign"
                   [style.textAlign]="componente.estilos.textAlign"
                   [style.fontFamily]="componente.estilos.fontFamily"
                   [style.borderStyle]="componente.estilos.borderStyle || 'none'"
                   [style.borderWidth]="componente.estilos.borderStyle !== 'none' ? (componente.estilos.borderWidth || '1px') : '0'"
                   [style.borderColor]="componente.estilos.borderColor || '#cccccc'"
                   [style.padding]="componente.estilos.borderStyle !== 'none' ? '15px' : '15px'">
                <div class="perfil-avatar-container">
                  <img class="img-60 rounded-circle perfil-avatar-img"
                       [src]="componente.contenido.avatarUrl || 'assets/images/dashboard/man.png'"
                       alt="Avatar">
                </div>
                <h6 class="mt-3 f-14 perfil-nombre" [style.color]="componente.estilos.color">{{ componente.contenido.nombre }}</h6>
                <p class="perfil-rol">{{ componente.contenido.rol }}</p>
                <p class="perfil-bio">{{ componente.contenido.bio }}</p>
              </div>

              <!-- REDES SOCIALES -->
              <div *ngSwitchCase="'redes'" 
                   class="redes-sociales"
                   [style.textAlign]="componente.estilos.textAlign"
                   [style.borderStyle]="componente.estilos.borderStyle || 'none'"
                   [style.borderWidth]="componente.estilos.borderStyle !== 'none' ? (componente.estilos.borderWidth || '1px') : '0'"
                   [style.borderColor]="componente.estilos.borderColor || '#cccccc'"
                   [style.padding]="componente.estilos.borderStyle !== 'none' ? '10px' : '0'">
                 <a *ngIf="componente.contenido.facebook" 
                   [attr.href]="!modoEdicion ? componente.contenido.facebook : null"
                   [attr.target]="!modoEdicion ? '_blank' : null"
                   class="social-icon facebook"
                   [class.disabled]="modoEdicion">
                  <i class="fab fa-facebook-f" [style.fontSize]="componente.estilos.iconSize"></i>
                </a>
                 <a *ngIf="componente.contenido.twitter" 
                   [attr.href]="!modoEdicion ? componente.contenido.twitter : null"
                   [attr.target]="!modoEdicion ? '_blank' : null"
                   class="social-icon twitter"
                   [class.disabled]="modoEdicion">
                  <i class="fab fa-twitter" [style.fontSize]="componente.estilos.iconSize"></i>
                </a>
                 <a *ngIf="componente.contenido.instagram" 
                   [attr.href]="!modoEdicion ? componente.contenido.instagram : null"
                   [attr.target]="!modoEdicion ? '_blank' : null"
                   class="social-icon instagram"
                   [class.disabled]="modoEdicion">
                  <i class="fab fa-instagram" [style.fontSize]="componente.estilos.iconSize"></i>
                </a>
                 <a *ngIf="componente.contenido.linkedin" 
                   [attr.href]="!modoEdicion ? componente.contenido.linkedin : null"
                   [attr.target]="!modoEdicion ? '_blank' : null"
                   class="social-icon linkedin"
                   [class.disabled]="modoEdicion">
                  <i class="fab fa-linkedin-in" [style.fontSize]="componente.estilos.iconSize"></i>
                </a>
                 <a *ngIf="componente.contenido.youtube" 
                   [attr.href]="!modoEdicion ? componente.contenido.youtube : null"
                   [attr.target]="!modoEdicion ? '_blank' : null"
                   class="social-icon youtube"
                   [class.disabled]="modoEdicion">
                  <i class="fab fa-youtube" [style.fontSize]="componente.estilos.iconSize"></i>
                </a>
                 <a *ngIf="componente.contenido.tiktok" 
                   [attr.href]="!modoEdicion ? componente.contenido.tiktok : null"
                   [attr.target]="!modoEdicion ? '_blank' : null"
                   class="social-icon tiktok"
                   [class.disabled]="modoEdicion">
                  <i class="fab fa-tiktok" [style.fontSize]="componente.estilos.iconSize"></i>
                </a>
              </div>

              <!-- BOTÓN -->
              <div *ngSwitchCase="'boton'" [style.textAlign]="componente.estilos.textAlign || 'center'">
                <a [attr.href]="!modoEdicion ? componente.contenido.url : null"
                   [attr.target]="!modoEdicion ? '_blank' : null"
                   class="btn-custom"
                   [class.disabled]="modoEdicion"
                   [style.backgroundColor]="componente.estilos.backgroundColor"
                   [style.color]="componente.estilos.color"
                   [style.fontFamily]="componente.estilos.fontFamily"
                   [style.padding]="componente.estilos.padding"
                   [style.borderRadius]="componente.estilos.borderRadius"
                   [style.borderStyle]="componente.estilos.borderStyle || 'none'"
                   [style.borderWidth]="componente.estilos.borderStyle !== 'none' ? (componente.estilos.borderWidth || '1px') : '0'"
                   [style.borderColor]="componente.estilos.borderColor || '#cccccc'">
                  {{ componente.contenido.texto }}
                </a>
              </div>

              <!-- ESPACIADOR -->
              <div *ngSwitchCase="'espaciador'" 
                   [style.height]="componente.estilos.height"
                   [style.borderStyle]="componente.estilos.borderStyle || 'none'"
                   [style.borderWidth]="componente.estilos.borderStyle !== 'none' ? (componente.estilos.borderWidth || '1px') : '0'"
                   [style.borderColor]="componente.estilos.borderColor || '#cccccc'"
                   class="espaciador">
              </div>

              <!-- BANNER -->
              <div *ngSwitchCase="'banner'" 
                   class="banner-component"
                   [style.backgroundImage]="'url(' + componente.contenido.url + ')'"
                   [style.backgroundSize]="'cover'"
                   [style.backgroundPosition]="'center'"
                   [style.position]="'relative'"
                   [style.minHeight]="'300px'"
                   [style.borderRadius]="componente.estilos?.borderRadius || '8px'"
                   [style.overflow]="'hidden'">
                <div [style.position]="'absolute'" 
                     [style.top]="'0'" 
                     [style.left]="'0'" 
                     [style.right]="'0'" 
                     [style.bottom]="'0'" 
                     [style.backgroundColor]="componente.estilos?.overlayColor || 'rgba(0,0,0,0.4)'"
                     [style.display]="'flex'"
                     [style.flexDirection]="'column'"
                     [style.justifyContent]="'center'"
                     [style.alignItems]="'center'"
                     [style.textAlign]="componente.estilos?.textAlign || 'center'"
                     [style.padding]="componente.estilos?.padding || '20px'"
                     [style.fontFamily]="componente.estilos?.fontFamily">
                  <h2 [style.color]="componente.estilos?.colorTitulo || '#fff'" [style.fontSize]="'32px'" [style.margin]="'0 0 10px 0'">
                    {{ componente.contenido.titulo }}
                  </h2>
                  <p *ngIf="componente.contenido.subtitulo" [style.color]="componente.estilos?.colorSubtitulo || '#f0f0f0'" [style.fontSize]="'18px'" [style.margin]="'0 0 20px 0'">
                    {{ componente.contenido.subtitulo }}
                  </p>
                  <a *ngIf="componente.contenido.textoBoton && componente.contenido.urlBoton" 
                     [href]="!modoEdicion ? componente.contenido.urlBoton : 'javascript:void(0)'"
                     [attr.target]="!modoEdicion ? '_blank' : null"
                     (click)="modoEdicion ? $event.preventDefault() : null"
                     class="btn-custom"
                     [class.disabled]="modoEdicion"
                     style="padding: 10px 30px; background-color: rgba(255,255,255,0.9); color: #333; border-radius: 4px; text-decoration: none; font-weight: 600; display: inline-block;">
                    {{ componente.contenido.textoBoton }}
                  </a>
                </div>
              </div>

              <!-- DESCUENTO -->
              <div *ngSwitchCase="'descuento'" 
                   class="descuento-component"
                   [style.backgroundColor]="componente.estilos?.backgroundColor || '#f8f9fa'"
                   [style.padding]="componente.estilos?.padding || '20px'"
                   [style.borderRadius]="componente.estilos?.borderRadius || '8px'"
                   [style.textAlign]="componente.estilos?.textAlign || 'center'"
                   [style.fontFamily]="componente.estilos?.fontFamily">
                <div [style.marginBottom]="'15px'">
                  <p *ngIf="componente.contenido.textoDescuento" [style.color]="componente.estilos?.colorTexto" [style.fontSize]="'14px'" [style.margin]="'0 0 10px 0'">
                    {{ componente.contenido.textoDescuento }}
                  </p>
                  <p [style.fontSize]="'12px'" [style.color]="'#ff6b6b'" [style.margin]="'5px 0'">
                    {{ calcularPorcentajeDescuento(componente.contenido.precioOriginal, componente.contenido.precioDescuento) }}% DESCUENTO
                  </p>
                </div>
                <div [style.marginBottom]="'15px'">
                  <span [style.fontSize]="'18px'" [style.color]="componente.estilos?.colorPrecioOriginal" [style.textDecoration]="'line-through'" [style.marginRight]="'10px'">
                    {{ componente.contenido.moneda }} {{ componente.contenido.precioOriginal }}
                  </span>
                  <span [style.fontSize]="'28px'" [style.color]="componente.estilos?.colorPrecioDescuento" [style.fontWeight]="'bold'">
                    {{ componente.contenido.moneda }} {{ componente.contenido.precioDescuento }}
                  </span>
                </div>
                <div *ngIf="componente.contenido.mostrarContador" [style.marginTop]="'15px'">
                  <p [style.color]="componente.estilos?.colorTexto" [style.fontSize]="'14px'" [style.margin]="'0 0 8px 0'">
                    Oferta termina en:
                  </p>
                  <div [style.fontSize]="'20px'" [style.color]="'#ff6b6b'" [style.fontWeight]="'bold'">
                    {{ contadorValores[componente.id] || '00:00:00' }}
                  </div>
                </div>
              </div>

              <!-- FILA CON COLUMNAS -->
              <div *ngSwitchCase="'fila'" class="row-component" [style.gap]="componente.estilos.gap">
                 <div class="column" 
                     *ngFor="let columna of componente.columnas; let colIndex = index; trackBy: trackByColumnIndex"
                     [style.flex]="(componente.estilos?.colWidths?.[colIndex] || '1') + ' 1 0'"
                   [style.background]="componente.estilos?.colBgColors?.[colIndex] || null"
                    [style.borderStyle]="componente.estilos?.colBorderStyles?.[colIndex] || 'none'"
                    [style.borderWidth]="(componente.estilos?.colBorderStyles?.[colIndex] && componente.estilos?.colBorderStyles?.[colIndex] !== 'none') ? (componente.estilos?.colBorderWidths?.[colIndex] || '1px') : '0'"
                    [style.borderColor]="componente.estilos?.colBorderColors?.[colIndex] || '#cccccc'"
                     (click)="modoEdicion && seleccionarColumnaYFila(componente, colIndex); $event.stopPropagation()">
                  
                  <!-- Mensaje cuando la columna está vacía -->
                  <div class="column-empty" 
                       *ngIf="!columna || columna.length === 0"
                       [class.selected-column]="columnaSeleccionada?.filaId === componente.id && columnaSeleccionada?.columnaIndex === colIndex">
                    <i class="fas fa-plus-circle"></i>
                    <p>Columna {{ colIndex + 1 }}</p>
                    <small>Haz click y edita desde propiedades</small>
                  </div>

                  <!-- Renderizar componentes dentro de la columna -->
                  <div class="column-content" 
                       *ngIf="columna && columna.length > 0"
                       [class.selected-column]="columnaSeleccionada?.filaId === componente.id && columnaSeleccionada?.columnaIndex === colIndex">
                    <div *ngFor="let comp of columna; let compIndex = index; trackBy: trackByComponenteId" 
                      class="column-component"
                      [style.marginBottom]="settings.moduleSpacing">
                      
                      <div [ngSwitch]="comp.tipo">
                        <div *ngSwitchCase="'titulo'" 
                             [style.fontSize]="comp.estilos.fontSize"
                             [style.color]="comp.estilos.color"
                             [style.textAlign]="comp.estilos.textAlign"
                             [style.fontWeight]="comp.estilos.fontWeight"
                             [style.fontFamily]="comp.estilos.fontFamily"
                             [style.borderStyle]="comp.estilos.borderStyle || 'none'"
                             [style.borderWidth]="comp.estilos.borderStyle !== 'none' ? (comp.estilos.borderWidth || '1px') : '0'"
                             [style.borderColor]="comp.estilos.borderColor || '#cccccc'"
                             [style.padding]="comp.estilos.borderStyle !== 'none' ? '10px' : '0'">
                          {{ comp.contenido.texto }}
                        </div>
                        
                        <div *ngSwitchCase="'texto'"
                             [style.fontSize]="comp.estilos.fontSize"
                             [style.color]="comp.estilos.color"
                             [style.textAlign]="comp.estilos.textAlign"
                             [style.fontFamily]="comp.estilos.fontFamily"
                             [style.borderStyle]="comp.estilos.borderStyle || 'none'"
                             [style.borderWidth]="comp.estilos.borderStyle !== 'none' ? (comp.estilos.borderWidth || '1px') : '0'"
                             [style.borderColor]="comp.estilos.borderColor || '#cccccc'"
                             [style.padding]="comp.estilos.borderStyle !== 'none' ? '10px' : '0'"
                             [innerHTML]="comp.contenido.texto">
                        </div>
                        
                        <div *ngSwitchCase="'imagen'" [style.textAlign]="comp.estilos?.textAlign || 'center'">
                          <img [src]="comp.contenido.url" 
                               [alt]="comp.contenido.alt"
                               [style.width]="comp.estilos?.width || '100%'"
                               [style.maxWidth]="comp.estilos?.maxWidth || '100%'"
                               [style.borderStyle]="comp.estilos?.borderStyle || 'none'"
                               [style.borderWidth]="comp.estilos?.borderStyle !== 'none' ? (comp.estilos?.borderWidth || '1px') : '0'"
                               [style.borderColor]="comp.estilos?.borderColor || '#cccccc'"
                               [style.display]="'inline-block'"
                               style="height: auto;">
                        </div>
                        
                        <div *ngSwitchCase="'boton'" [style.textAlign]="'center'">
                          <a [href]="!modoEdicion ? comp.contenido.url : 'javascript:void(0)'"
                             [attr.target]="!modoEdicion ? '_blank' : null"
                             (click)="modoEdicion ? $event.preventDefault() : null"
                             class="btn-custom"
                             [class.disabled]="modoEdicion"
                             [style.backgroundColor]="comp.estilos.backgroundColor"
                             [style.color]="comp.estilos.color"
                             [style.fontFamily]="comp.estilos.fontFamily"
                             [style.padding]="comp.estilos.padding"
                             [style.borderRadius]="comp.estilos.borderRadius"
                             [style.borderStyle]="comp.estilos.borderStyle || 'none'"
                             [style.borderWidth]="comp.estilos.borderStyle !== 'none' ? (comp.estilos.borderWidth || '1px') : '0'"
                             [style.borderColor]="comp.estilos.borderColor || '#cccccc'"
                             style="display: inline-block; max-width: 100%; word-wrap: break-word;">
                            {{ comp.contenido.texto }}
                          </a>
                        </div>

                        <div *ngSwitchCase="'perfil'" class="perfil-component sidebar-user" [attr.data-align]="comp.estilos.textAlign" [style.textAlign]="comp.estilos.textAlign"
                             [style.fontFamily]="comp.estilos.fontFamily"
                             [style.borderStyle]="comp.estilos.borderStyle || 'none'"
                             [style.borderWidth]="comp.estilos.borderStyle !== 'none' ? (comp.estilos.borderWidth || '1px') : '0'"
                             [style.borderColor]="comp.estilos.borderColor || '#cccccc'"
                             [style.padding]="comp.estilos.borderStyle !== 'none' ? '15px' : '15px'">
                          <div class="perfil-avatar-container">
                            <img class="img-60 rounded-circle perfil-avatar-img"
                                 [src]="comp.contenido.avatarUrl || 'assets/images/dashboard/man.png'"
                                 alt="Avatar">
                          </div>
                          <h6 class="mt-3 f-14 perfil-nombre" [style.color]="comp.estilos.color">{{ comp.contenido.nombre }}</h6>
                          <p class="perfil-rol">{{ comp.contenido.rol }}</p>
                          <p class="perfil-bio">{{ comp.contenido.bio }}</p>
                        </div>

                        <div *ngSwitchCase="'contador'" 
                             [style.color]="comp.estilos.color"
                             [style.fontSize]="comp.estilos.fontSize"
                             [style.textAlign]="comp.estilos.textAlign"
                             [style.fontWeight]="comp.estilos.fontWeight"
                             [style.fontFamily]="comp.estilos.fontFamily"
                             [style.borderStyle]="comp.estilos.borderStyle || 'none'"
                             [style.borderWidth]="comp.estilos.borderStyle !== 'none' ? (comp.estilos.borderWidth || '1px') : '0'"
                             [style.borderColor]="comp.estilos.borderColor || '#cccccc'"
                             [style.padding]="comp.estilos.borderStyle !== 'none' ? '10px' : '0'"
                             style="text-align:center;">
                          {{ contadorValores[comp.id] || '00:00:00' }}
                        </div>

                        <div *ngSwitchCase="'espaciador'"
                             class="espaciador"
                             [style.height]="comp.estilos?.height || '24px'"
                             [style.borderStyle]="comp.estilos?.borderStyle || 'none'"
                             [style.borderWidth]="comp.estilos?.borderStyle !== 'none' ? (comp.estilos?.borderWidth || '1px') : '0'"
                             [style.borderColor]="comp.estilos?.borderColor || '#cccccc'">
                        </div>

                        <div *ngSwitchCase="'redes'" class="redes-sociales" [style.textAlign]="comp.estilos?.textAlign || 'center'"
                             [style.borderStyle]="comp.estilos?.borderStyle || 'none'"
                             [style.borderWidth]="comp.estilos?.borderStyle !== 'none' ? (comp.estilos?.borderWidth || '1px') : '0'"
                             [style.borderColor]="comp.estilos?.borderColor || '#cccccc'"
                             [style.padding]="comp.estilos?.borderStyle !== 'none' ? '10px' : '0'">
                          <a *ngIf="comp.contenido.facebook" [attr.href]="!modoEdicion ? comp.contenido.facebook : null" [attr.target]="!modoEdicion ? '_blank' : null" class="social-icon facebook"><i class="fab fa-facebook-f"></i></a>
                          <a *ngIf="comp.contenido.twitter" [attr.href]="!modoEdicion ? comp.contenido.twitter : null" [attr.target]="!modoEdicion ? '_blank' : null" class="social-icon twitter"><i class="fab fa-twitter"></i></a>
                          <a *ngIf="comp.contenido.instagram" [attr.href]="!modoEdicion ? comp.contenido.instagram : null" [attr.target]="!modoEdicion ? '_blank' : null" class="social-icon instagram"><i class="fab fa-instagram"></i></a>
                          <a *ngIf="comp.contenido.linkedin" [attr.href]="!modoEdicion ? comp.contenido.linkedin : null" [attr.target]="!modoEdicion ? '_blank' : null" class="social-icon linkedin"><i class="fab fa-linkedin-in"></i></a>
                          <a *ngIf="comp.contenido.youtube" [attr.href]="!modoEdicion ? comp.contenido.youtube : null" [attr.target]="!modoEdicion ? '_blank' : null" class="social-icon youtube"><i class="fab fa-youtube"></i></a>
                          <a *ngIf="comp.contenido.tiktok" [attr.href]="!modoEdicion ? comp.contenido.tiktok : null" [attr.target]="!modoEdicion ? '_blank' : null" class="social-icon tiktok"><i class="fab fa-tiktok"></i></a>
                        </div>

                        <!-- BANNER -->
                        <div *ngSwitchCase="'banner'" 
                             class="banner-component"
                             [style.backgroundImage]="'url(' + comp.contenido.url + ')'"
                             [style.backgroundSize]="'cover'"
                             [style.backgroundPosition]="'center'"
                             [style.position]="'relative'"
                             [style.minHeight]="'300px'"
                             [style.borderRadius]="comp.estilos?.borderRadius || '8px'"
                             [style.overflow]="'hidden'">
                          <div [style.position]="'absolute'" 
                               [style.top]="'0'" 
                               [style.left]="'0'" 
                               [style.right]="'0'" 
                               [style.bottom]="'0'" 
                               [style.backgroundColor]="comp.estilos?.overlayColor || 'rgba(0,0,0,0.4)'"
                               [style.display]="'flex'"
                               [style.flexDirection]="'column'"
                               [style.justifyContent]="'center'"
                               [style.alignItems]="'center'"
                               [style.textAlign]="comp.estilos?.textAlign || 'center'"
                               [style.padding]="comp.estilos?.padding || '20px'"
                               [style.fontFamily]="comp.estilos?.fontFamily">
                            <h2 [style.color]="comp.estilos?.colorTitulo || '#fff'" [style.fontSize]="'32px'" [style.margin]="'0 0 10px 0'">
                              {{ comp.contenido.titulo }}
                            </h2>
                            <p *ngIf="comp.contenido.subtitulo" [style.color]="comp.estilos?.colorSubtitulo || '#f0f0f0'" [style.fontSize]="'18px'" [style.margin]="'0 0 20px 0'">
                              {{ comp.contenido.subtitulo }}
                            </p>
                            <a *ngIf="comp.contenido.textoBoton && comp.contenido.urlBoton" 
                               [href]="!modoEdicion ? comp.contenido.urlBoton : 'javascript:void(0)'"
                               [attr.target]="!modoEdicion ? '_blank' : null"
                               (click)="modoEdicion ? $event.preventDefault() : null"
                               class="btn-custom"
                               [class.disabled]="modoEdicion"
                               style="padding: 10px 30px; background-color: rgba(255,255,255,0.9); color: #333; border-radius: 4px; text-decoration: none; font-weight: 600; display: inline-block;">
                              {{ comp.contenido.textoBoton }}
                            </a>
                          </div>
                        </div>

                        <!-- DESCUENTO -->
                        <div *ngSwitchCase="'descuento'" 
                             class="descuento-component"
                             [style.backgroundColor]="comp.estilos?.backgroundColor || '#f8f9fa'"
                             [style.padding]="comp.estilos?.padding || '20px'"
                             [style.borderRadius]="comp.estilos?.borderRadius || '8px'"
                             [style.textAlign]="comp.estilos?.textAlign || 'center'"
                             [style.fontFamily]="comp.estilos?.fontFamily">
                          <div [style.marginBottom]="'15px'">
                            <p *ngIf="comp.contenido.textoDescuento" [style.color]="comp.estilos?.colorTexto" [style.fontSize]="'14px'" [style.margin]="'0 0 10px 0'">
                              {{ comp.contenido.textoDescuento }}
                            </p>
                            <p [style.fontSize]="'12px'" [style.color]="'#ff6b6b'" [style.margin]="'5px 0'">
                              {{ calcularPorcentajeDescuento(comp.contenido.precioOriginal, comp.contenido.precioDescuento) }}% DESCUENTO
                            </p>
                          </div>
                          <div [style.marginBottom]="'15px'">
                            <span [style.fontSize]="'18px'" [style.color]="comp.estilos?.colorPrecioOriginal" [style.textDecoration]="'line-through'" [style.marginRight]="'10px'">
                              {{ comp.contenido.moneda }} {{ comp.contenido.precioOriginal }}
                            </span>
                            <span [style.fontSize]="'28px'" [style.color]="comp.estilos?.colorPrecioDescuento" [style.fontWeight]="'bold'">
                              {{ comp.contenido.moneda }} {{ comp.contenido.precioDescuento }}
                            </span>
                          </div>
                          <div *ngIf="comp.contenido.mostrarContador" [style.marginTop]="'15px'">
                            <p [style.color]="comp.estilos?.colorTexto" [style.fontSize]="'14px'" [style.margin]="'0 0 8px 0'">
                              Oferta termina en:
                            </p>
                            <div [style.fontSize]="'20px'" [style.color]="'#ff6b6b'" [style.fontWeight]="'bold'">
                              {{ contadorValores[comp.id] || '00:00:00' }}
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- Panel de propiedades (derecha) -->
      <div class="sidebar-properties" [class.collapsed]="propertiesColapsada" *ngIf="modoEdicion">
        <h4 class="sidebar-title">
          <span *ngIf="!propertiesColapsada">Propiedades</span>
          <button class="collapse-btn" (click)="toggleProperties()" title="Colapsar/Expandir">
            <i class="fas" [class.fa-chevron-right]="!propertiesColapsada" [class.fa-chevron-left]="propertiesColapsada"></i>
          </button>
        </h4>
        
        <!-- Mensaje cuando no hay componente seleccionado -->
        <div class="no-selection" *ngIf="!propertiesColapsada && !componenteSeleccionado">
          <i class="fas fa-mouse-pointer"></i>
          <p>Selecciona un componente para editar sus propiedades</p>
          <div class="form-group" style="width:100%; max-width:260px; margin-top:10px;">
            <label>Color de fondo de la página</label>
            <input type="color" class="form-control" [ngModel]="settings.backgroundColor" (ngModelChange)="actualizarBackgroundColor($event)">
          </div>
          <div class="form-group" style="width:100%; max-width:260px; margin-top:10px;">
            <label>Espaciado entre módulos</label>
            <input type="text" class="form-control" [(ngModel)]="settings.moduleSpacing" (ngModelChange)="guardarConfiguracion()" placeholder="30px">
          </div>
        </div>
        
        <div class="properties-content" *ngIf="!propertiesColapsada && componenteSeleccionado">
          
          <!-- Propiedades de TÍTULO -->
          <div *ngIf="componenteSeleccionado.tipo === 'titulo'">
            <div class="form-group">
              <label>Texto</label>
              <input type="text" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.contenido.texto"
                     (ngModelChange)="guardarConfiguracion()">
            </div>
            <div class="form-group">
              <label>Tamaño</label>
              <input type="text" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.estilos.fontSize"
                     (ngModelChange)="guardarConfiguracion()"
                     placeholder="32px">
            </div>
            <div class="form-group">
              <label>Color</label>
              <input type="color" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.estilos.color"
                     (ngModelChange)="guardarConfiguracion()">
            </div>
            <div class="form-group">
              <label>Alineación</label>
              <select class="form-control" 
                      [(ngModel)]="componenteSeleccionado.estilos.textAlign"
                      (ngModelChange)="guardarConfiguracion()">
                <option value="left">Izquierda</option>
                <option value="center">Centro</option>
                <option value="right">Derecha</option>
              </select>
            </div>
            <div class="form-group">
              <label>Tipografía</label>
              <select class="form-control" 
                      [(ngModel)]="componenteSeleccionado.estilos.fontFamily"
                      (ngModelChange)="guardarConfiguracion()">
                <option *ngFor="let font of tipografiasDisponibles" [value]="font.value">{{ font.label }}</option>
              </select>
            </div>
          </div>

          <!-- Propiedades de TEXTO -->
          <div *ngIf="componenteSeleccionado.tipo === 'texto'">
            <div class="form-group">
              <label>Contenido</label>
              <textarea class="form-control" 
                        rows="5"
                        [(ngModel)]="componenteSeleccionado.contenido.texto"
                        (ngModelChange)="guardarConfiguracion()"></textarea>
            </div>
            <div class="form-group">
              <label>Tamaño</label>
              <input type="text" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.estilos.fontSize"
                     (ngModelChange)="guardarConfiguracion()"
                     placeholder="16px">
            </div>
            <div class="form-group">
              <label>Color</label>
              <input type="color" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.estilos.color"
                     (ngModelChange)="guardarConfiguracion()">
            </div>
            <div class="form-group">
              <label>Alineación</label>
              <select class="form-control" 
                      [(ngModel)]="componenteSeleccionado.estilos.textAlign"
                      (ngModelChange)="guardarConfiguracion()">
                <option value="left">Izquierda</option>
                <option value="center">Centro</option>
                <option value="right">Derecha</option>
                <option value="justify">Justificado</option>
              </select>
            </div>
            <div class="form-group">
              <label>Tipografía</label>
              <select class="form-control" 
                      [(ngModel)]="componenteSeleccionado.estilos.fontFamily"
                      (ngModelChange)="guardarConfiguracion()">
                <option *ngFor="let font of tipografiasDisponibles" [value]="font.value">{{ font.label }}</option>
              </select>
            </div>
          </div>

          <!-- Propiedades de IMAGEN -->
          <div *ngIf="componenteSeleccionado.tipo === 'imagen'">
            
            <!-- Preview de la imagen -->
            <div class="form-group" *ngIf="componenteSeleccionado.contenido.url">
              <label>Preview</label>
              <div class="image-preview">
                <img [src]="componenteSeleccionado.contenido.url" 
                     [alt]="componenteSeleccionado.contenido.alt"
                     style="max-width: 100%; border-radius: 4px; border: 1px solid #dee2e6;">
              </div>
            </div>

            <div class="form-group">
              <label>Subir imagen</label>
              <input type="file" 
                     class="form-control" 
                     accept="image/*"
                     (change)="onImagenSelected($event, componenteSeleccionado)">
              <small *ngIf="componenteSeleccionado.contenido.fileName && !componenteSeleccionado.contenido.uploading" class="text-muted">Archivo: {{ componenteSeleccionado.contenido.fileName }}</small>
              <small *ngIf="componenteSeleccionado.contenido.uploading" class="text-warning">Subiendo imagen...</small>
              <small *ngIf="componenteSeleccionado.contenido.uploadError" class="text-danger">{{ componenteSeleccionado.contenido.uploadError }}</small>
            </div>

            <div class="form-group">
              <label>Texto alternativo</label>
              <input type="text" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.contenido.alt"
                     (ngModelChange)="guardarConfiguracion()"
                     placeholder="Descripción de la imagen">
            </div>
            <div class="form-group">
              <label>Ancho</label>
              <input type="text" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.estilos.width"
                     (ngModelChange)="guardarConfiguracion()"
                     placeholder="100%">
            </div>
            <div class="form-group">
              <label>Ancho máximo</label>
              <input type="text" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.estilos.maxWidth"
                     (ngModelChange)="guardarConfiguracion()"
                     placeholder="600px">
            </div>
            
            <div class="form-group">
              <label>Alineación</label>
              <select class="form-control" 
                      [(ngModel)]="componenteSeleccionado.estilos.textAlign"
                      (ngModelChange)="guardarConfiguracion()">
                <option value="left">Izquierda</option>
                <option value="center">Centro</option>
                <option value="right">Derecha</option>
              </select>
            </div>
          </div>

          <!-- Propiedades de PERFIL -->
          <div *ngIf="componenteSeleccionado.tipo === 'perfil'">
            <div class="form-group">
              <label>Avatar</label>
              <input type="file" class="form-control" accept="image/*" (change)="onAvatarSelected($event, componenteSeleccionado)">
              <div class="image-preview" *ngIf="componenteSeleccionado.contenido.avatarUrl" style="margin-top:8px;">
                <img [src]="componenteSeleccionado.contenido.avatarUrl" alt="Avatar" style="max-width:100px; border-radius:50%;">
              </div>
              <small *ngIf="componenteSeleccionado.contenido.avatarName && !componenteSeleccionado.contenido.avatarUploading" class="text-muted">Archivo: {{ componenteSeleccionado.contenido.avatarName }}</small>
              <small *ngIf="componenteSeleccionado.contenido.avatarUploading" class="text-warning">Subiendo avatar...</small>
              <small *ngIf="componenteSeleccionado.contenido.avatarUploadError" class="text-danger">{{ componenteSeleccionado.contenido.avatarUploadError }}</small>
            </div>
            <div class="form-group">
              <label>Nombre</label>
              <input type="text" class="form-control" [(ngModel)]="componenteSeleccionado.contenido.nombre" (ngModelChange)="guardarConfiguracion()">
            </div>
            <div class="form-group">
              <label>Rol</label>
              <input type="text" class="form-control" [(ngModel)]="componenteSeleccionado.contenido.rol" (ngModelChange)="guardarConfiguracion()">
            </div>
            <div class="form-group">
              <label>Bio</label>
              <textarea class="form-control" rows="3" [(ngModel)]="componenteSeleccionado.contenido.bio" (ngModelChange)="guardarConfiguracion()"></textarea>
            </div>
            <div class="form-group">
              <label>Alineación</label>
              <select class="form-control" [(ngModel)]="componenteSeleccionado.estilos.textAlign" (ngModelChange)="guardarConfiguracion()">
                <option value="left">Izquierda</option>
                <option value="center">Centro</option>
                <option value="right">Derecha</option>
                <option value="justify">Justificar</option>
              </select>
            </div>
            <div class="form-group">
              <label>Color de nombre</label>
              <input type="color" class="form-control" [(ngModel)]="componenteSeleccionado.estilos.color" (ngModelChange)="guardarConfiguracion()">
            </div>
            <div class="form-group">
              <label>Tipografía</label>
              <select class="form-control" 
                      [(ngModel)]="componenteSeleccionado.estilos.fontFamily"
                      (ngModelChange)="guardarConfiguracion()">
                <option *ngFor="let font of tipografiasDisponibles" [value]="font.value">{{ font.label }}</option>
              </select>
            </div>
          </div>

          <!-- Propiedades de REDES SOCIALES -->
          <div *ngIf="componenteSeleccionado.tipo === 'redes'">
            <div class="form-group">
              <label><i class="fab fa-facebook-f me-2" style="color: #3b5998;"></i>Facebook</label>
              <input type="url" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.contenido.facebook"
                     (ngModelChange)="guardarConfiguracion()"
                     placeholder="https://facebook.com/...">
            </div>
            <div class="form-group">
              <label><i class="fab fa-twitter me-2" style="color: #1da1f2;"></i>Twitter</label>
              <input type="url" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.contenido.twitter"
                     (ngModelChange)="guardarConfiguracion()"
                     placeholder="https://twitter.com/...">
            </div>
            <div class="form-group">
              <label><i class="fab fa-instagram me-2" style="color: #e4405f;"></i>Instagram</label>
              <input type="url" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.contenido.instagram"
                     (ngModelChange)="guardarConfiguracion()"
                     placeholder="https://instagram.com/...">
            </div>
            <div class="form-group">
              <label><i class="fab fa-linkedin-in me-2" style="color: #0077b5;"></i>LinkedIn</label>
              <input type="url" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.contenido.linkedin"
                     (ngModelChange)="guardarConfiguracion()"
                     placeholder="https://linkedin.com/...">
            </div>
            <div class="form-group">
              <label><i class="fab fa-youtube me-2" style="color: #ff0000;"></i>YouTube</label>
              <input type="url" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.contenido.youtube"
                     (ngModelChange)="guardarConfiguracion()"
                     placeholder="https://youtube.com/...">
            </div>
            <div class="form-group">
              <label><i class="fab fa-tiktok me-2" style="color: #000000;"></i>TikTok</label>
              <input type="url" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.contenido.tiktok"
                     (ngModelChange)="guardarConfiguracion()"
                     placeholder="https://tiktok.com/@...">
            </div>
            <div class="form-group">
              <label><i class="fas fa-text-height me-2"></i>Tamaño de iconos</label>
              <input type="text" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.estilos.iconSize"
                     (ngModelChange)="guardarConfiguracion()"
                     placeholder="32px">
            </div>
          </div>

          <!-- Propiedades de BOTÓN -->
          <div *ngIf="componenteSeleccionado.tipo === 'boton'">
            <div class="form-group">
              <label>Texto del botón</label>
              <input type="text" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.contenido.texto"
                     (ngModelChange)="guardarConfiguracion()">
            </div>
            <div class="form-group">
              <label>URL / Enlace</label>
              <input type="text" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.contenido.url"
                     (ngModelChange)="guardarConfiguracion()">
            </div>
            <div class="form-group">
              <label>Color de fondo</label>
              <input type="color" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.estilos.backgroundColor"
                     (ngModelChange)="guardarConfiguracion()">
            </div>
            <div class="form-group">
              <label>Color del texto</label>
              <input type="color" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.estilos.color"
                     (ngModelChange)="guardarConfiguracion()">
            </div>
            <div class="form-group">
              <label>Tipografía</label>
              <select class="form-control" 
                      [(ngModel)]="componenteSeleccionado.estilos.fontFamily"
                      (ngModelChange)="guardarConfiguracion()">
                <option *ngFor="let font of tipografiasDisponibles" [value]="font.value">{{ font.label }}</option>
              </select>
            </div>
          </div>

          <!-- Propiedades de ESPACIADOR -->
          <div *ngIf="componenteSeleccionado.tipo === 'espaciador'">
            <div class="form-group">
              <label>Altura</label>
              <input type="text" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.estilos.height"
                     (ngModelChange)="guardarConfiguracion()"
                     placeholder="40px">
            </div>
            <div class="form-group" style="border-top: 1px solid #e9ecef; padding-top: 10px; margin-top: 10px;">
              <label>Estilo</label>
              <select class="form-control" [(ngModel)]="componenteSeleccionado.estilos.borderStyle" (ngModelChange)="guardarConfiguracion()">
                <option value="none">Sin borde</option>
                <option value="solid">Sólido</option>
                <option value="dashed">Discontinuo</option>
                <option value="dotted">Punteado</option>
                <option value="double">Doble</option>
              </select>
            </div>
            <div class="form-group" *ngIf="componenteSeleccionado.estilos.borderStyle !== 'none'">
              <label>Color</label>
              <input type="color" class="form-control" [(ngModel)]="componenteSeleccionado.estilos.borderColor" (ngModelChange)="guardarConfiguracion()">
            </div>
          </div>

          <!-- Propiedades de CONTADOR -->
          <div *ngIf="componenteSeleccionado.tipo === 'contador'">
            <div class="form-group">
              <label>Fecha y hora objetivo</label>
              <input type="datetime-local"
                class="form-control"
                [ngModel]="(componenteSeleccionado.contenido.targetDate | date:'yyyy-MM-dd\'T\'HH:mm')"
                (ngModelChange)="onDateTimeChange(componenteSeleccionado, $event)">
            </div>
            <div class="form-group">
              <label>Color</label>
              <input type="color" class="form-control" [(ngModel)]="componenteSeleccionado.estilos.color" (ngModelChange)="guardarConfiguracion()">
            </div>
            <div class="form-group">
              <label>Tamaño de fuente</label>
              <input type="text" class="form-control" [(ngModel)]="componenteSeleccionado.estilos.fontSize" (ngModelChange)="guardarConfiguracion()" placeholder="24px">
            </div>
            <div class="form-group">
              <label>Color de fondo</label>
              <input type="color" class="form-control" [(ngModel)]="componenteSeleccionado.estilos.backgroundColor" (ngModelChange)="guardarConfiguracion()">
            </div>
            <div class="form-group">
              <label>Padding</label>
              <input type="text" class="form-control" [(ngModel)]="componenteSeleccionado.estilos.padding" (ngModelChange)="guardarConfiguracion()" placeholder="10px">
            </div>
            <div class="form-group">
              <label>Radio de borde</label>
              <input type="text" class="form-control" [(ngModel)]="componenteSeleccionado.estilos.borderRadius" (ngModelChange)="guardarConfiguracion()" placeholder="5px">
            </div>
            <div class="form-group">
              <label>Tipografía</label>
              <select class="form-control" 
                      [(ngModel)]="componenteSeleccionado.estilos.fontFamily"
                      (ngModelChange)="guardarConfiguracion()">
                <option *ngFor="let font of tipografiasDisponibles" [value]="font.valor">{{ font.nombre }}</option>
              </select>
            </div>
          </div>

          <!-- Propiedades de FILA -->
          <div *ngIf="componenteSeleccionado.tipo === 'fila'">
            <div class="form-group">
              <label>Número de columnas</label>
              <select class="form-control" 
                      [ngModel]="componenteSeleccionado.contenido.numColumnas"
                      (ngModelChange)="actualizarNumeroColumnas(componenteSeleccionado, $event)">
                <option [value]="1">1 Columna</option>
                <option [value]="2">2 Columnas</option>
                <option [value]="3">3 Columnas</option>
                <option [value]="4">4 Columnas</option>
                <option [value]="6">6 Columnas</option>
              </select>
            </div>
            
            <div class="form-group">
              <label>Espacio entre columnas</label>
              <input type="text" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.estilos.gap"
                     (ngModelChange)="guardarConfiguracion()"
                     placeholder="20px">
            </div>

            <!-- Lista de columnas con sus componentes -->
            <div class="columnas-config">
              <div class="columna-section" 
                   *ngFor="let columna of componenteSeleccionado.columnas; let colIdx = index"
                   [class.active]="columnaSeleccionada?.filaId === componenteSeleccionado.id && columnaSeleccionada?.columnaIndex === colIdx">
                <div class="columna-header" (click)="toggleColumnaExpanded(colIdx)">
                  <h5>
                    <i class="fas" [class.fa-chevron-down]="columnaExpandida === colIdx" [class.fa-chevron-right]="columnaExpandida !== colIdx"></i>
                    Columna {{ colIdx + 1 }} ({{ columna?.length || 0 }} componentes)
                  </h5>
                </div>

                <div class="columna-content" *ngIf="columnaExpandida === colIdx">
                  <div class="form-group">
                    <label>Ancho de columna (flex)</label>
                    <input type="text" class="form-control" [(ngModel)]="componenteSeleccionado.estilos.colWidths[colIdx]" (ngModelChange)="guardarConfiguracion()" placeholder="1" title="Valor de flex-grow (ej: 1, 2, 0.5)">
                    <small class="form-text text-muted">Valor relativo del ancho. Ej: 2 = doble de ancho que las demás</small>
                  </div>
                  <div class="form-group">
                    <label>Fondo de esta columna</label>
                    <input type="color" class="form-control" [(ngModel)]="componenteSeleccionado.estilos.colBgColors[colIdx]" (ngModelChange)="guardarConfiguracion()">
                  </div>
                  <div class="form-group" style="margin-top:8px; border-top:1px solid #e9ecef; padding-top:10px;">
                    <label>Estilo de borde</label>
                    <select class="form-control" [(ngModel)]="componenteSeleccionado.estilos.colBorderStyles[colIdx]" (ngModelChange)="guardarConfiguracion()">
                      <option value="none">Sin borde</option>
                      <option value="solid">Sólido</option>
                      <option value="dashed">Discontinuo</option>
                      <option value="dotted">Punteado</option>
                      <option value="double">Doble</option>
                    </select>
                  </div>
                  <div class="form-group" *ngIf="componenteSeleccionado.estilos.colBorderStyles[colIdx] !== 'none'">
                    <label>Ancho de borde</label>
                    <input type="text" class="form-control" [(ngModel)]="componenteSeleccionado.estilos.colBorderWidths[colIdx]" (ngModelChange)="guardarConfiguracion()" placeholder="1px">
                  </div>
                  <div class="form-group" *ngIf="componenteSeleccionado.estilos.colBorderStyles[colIdx] !== 'none'">
                    <label>Color de borde</label>
                    <input type="color" class="form-control" [(ngModel)]="componenteSeleccionado.estilos.colBorderColors[colIdx]" (ngModelChange)="guardarConfiguracion()">
                  </div>
                  <!-- Agregar nuevo componente -->
                  <div class="form-group">
                    <label>Agregar componente</label>
                    <select class="form-control" #selectComp (change)="agregarComponenteAColumna(componenteSeleccionado.id, colIdx, selectComp.value); selectComp.value = ''">
                      <option value="">-- Seleccionar tipo --</option>
                      <option value="titulo">Título</option>
                      <option value="texto">Texto</option>
                      <option value="imagen">Imagen</option>
                      <option value="boton">Botón</option>
                      <option value="redes">Redes Sociales</option>
                      <option value="espaciador">Espaciador</option>
                      <option value="contador">Contador</option>
                      <option value="perfil">Perfil</option>
                    </select>
                  </div>

                  <!-- Lista de componentes en la columna -->
                  <div class="componentes-lista" *ngIf="columna && columna.length > 0">
                    <div class="componente-item-config" 
                         *ngFor="let comp of columna; let compIdx = index"
                         [class.selected]="componenteColumnaSeleccionado?.filaId === componenteSeleccionado.id && componenteColumnaSeleccionado?.columnaIndex === colIdx && componenteColumnaSeleccionado?.componenteIndex === compIdx"
                         (click)="seleccionarComponenteColumna(componenteSeleccionado.id, colIdx, compIdx, comp); $event.stopPropagation()">
                      <div class="componente-item-header">
                        <span><i class="fas fa-{{ getTipoIcon(comp.tipo) }}"></i> {{ getTipoNombre(comp.tipo) }}</span>
                        <div class="componente-actions">
                          <button class="btn-icon" (click)="moverComponenteColumna(componenteSeleccionado.id, colIdx, compIdx, 'up'); $event.stopPropagation()" 
                                  [disabled]="compIdx === 0"
                                  title="Mover arriba">
                            <i class="fas fa-arrow-up"></i>
                          </button>
                          <button class="btn-icon" (click)="moverComponenteColumna(componenteSeleccionado.id, colIdx, compIdx, 'down'); $event.stopPropagation()" 
                                  [disabled]="compIdx === columna.length - 1"
                                  title="Mover abajo">
                            <i class="fas fa-arrow-down"></i>
                          </button>
                          <button class="btn-icon btn-danger" (click)="eliminarComponenteDeColumna(componenteSeleccionado.id, colIdx, compIdx); $event.stopPropagation()"
                                  title="Eliminar">
                            <i class="fas fa-trash"></i>
                          </button>
                        </div>
                      </div>

                      <!-- Edición rápida del componente seleccionado -->
                      <div class="componente-quick-edit" 
                           *ngIf="componenteColumnaSeleccionado?.filaId === componenteSeleccionado.id && componenteColumnaSeleccionado?.columnaIndex === colIdx && componenteColumnaSeleccionado?.componenteIndex === compIdx">
                        
                        <!-- Título -->
                        <div *ngIf="comp.tipo === 'titulo'">
                          <div class="form-group-sm">
                            <label>Texto</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="comp.contenido.texto" (ngModelChange)="guardarConfiguracion()">
                          </div>
                          <div class="form-group-sm">
                            <label>Tamaño</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="comp.estilos.fontSize" (ngModelChange)="guardarConfiguracion()" placeholder="28px">
                          </div>
                          <div class="form-group-sm">
                            <label>Color</label>
                            <input type="color" class="form-control form-control-sm" [(ngModel)]="comp.estilos.color" (ngModelChange)="guardarConfiguracion()">
                          </div>
                          <div class="form-group-sm">
                            <label>Alineación</label>
                            <select class="form-control form-control-sm" [(ngModel)]="comp.estilos.textAlign" (ngModelChange)="guardarConfiguracion()">
                              <option value="left">Izquierda</option>
                              <option value="center">Centro</option>
                              <option value="right">Derecha</option>
                            </select>
                          </div>
                          
                          <!-- Bordes -->
                          <div class="form-group-sm" style="border-top: 1px solid #e9ecef; padding-top: 10px; margin-top: 10px;">
                            <label style="font-weight: 600;">Borde</label>
                            <select class="form-control form-control-sm" [(ngModel)]="comp.estilos.borderStyle" (ngModelChange)="guardarConfiguracion()">
                              <option value="none">Sin borde</option>
                              <option value="solid">Sólido</option>
                              <option value="dashed">Discontinuo</option>
                              <option value="dotted">Punteado</option>
                              <option value="double">Doble</option>
                            </select>
                          </div>
                          <div class="form-group-sm" *ngIf="comp.estilos.borderStyle !== 'none'">
                            <label>Ancho</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="comp.estilos.borderWidth" (ngModelChange)="guardarConfiguracion()" placeholder="1px">
                          </div>
                          <div class="form-group-sm" *ngIf="comp.estilos.borderStyle !== 'none'">
                            <label>Color</label>
                            <input type="color" class="form-control form-control-sm" [(ngModel)]="comp.estilos.borderColor" (ngModelChange)="guardarConfiguracion()">
                          </div>
                        </div>

                        <!-- Texto -->
                        <div *ngIf="comp.tipo === 'texto'">
                          <div class="form-group-sm">
                            <label>Contenido</label>
                            <textarea class="form-control form-control-sm" rows="3" [(ngModel)]="comp.contenido.texto" (ngModelChange)="guardarConfiguracion()"></textarea>
                          </div>
                          <div class="form-group-sm">
                            <label>Tamaño</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="comp.estilos.fontSize" (ngModelChange)="guardarConfiguracion()" placeholder="16px">
                          </div>
                          <div class="form-group-sm">
                            <label>Color</label>
                            <input type="color" class="form-control form-control-sm" [(ngModel)]="comp.estilos.color" (ngModelChange)="guardarConfiguracion()">
                          </div>
                          <div class="form-group-sm">
                            <label>Alineación</label>
                            <select class="form-control form-control-sm" [(ngModel)]="comp.estilos.textAlign" (ngModelChange)="guardarConfiguracion()">
                              <option value="left">Izquierda</option>
                              <option value="center">Centro</option>
                              <option value="right">Derecha</option>
                              <option value="justify">Justificado</option>
                            </select>
                          </div>
                          
                          <!-- Bordes -->
                          <div class="form-group-sm" style="border-top: 1px solid #e9ecef; padding-top: 10px; margin-top: 10px;">
                            <label style="font-weight: 600;">Borde</label>
                            <select class="form-control form-control-sm" [(ngModel)]="comp.estilos.borderStyle" (ngModelChange)="guardarConfiguracion()">
                              <option value="none">Sin borde</option>
                              <option value="solid">Sólido</option>
                              <option value="dashed">Discontinuo</option>
                              <option value="dotted">Punteado</option>
                              <option value="double">Doble</option>
                            </select>
                          </div>
                          <div class="form-group-sm" *ngIf="comp.estilos.borderStyle !== 'none'">
                            <label>Ancho</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="comp.estilos.borderWidth" (ngModelChange)="guardarConfiguracion()" placeholder="1px">
                          </div>
                          <div class="form-group-sm" *ngIf="comp.estilos.borderStyle !== 'none'">
                            <label>Color</label>
                            <input type="color" class="form-control form-control-sm" [(ngModel)]="comp.estilos.borderColor" (ngModelChange)="guardarConfiguracion()">
                          </div>
                        </div>

                        <!-- Imagen -->
                        <div *ngIf="comp.tipo === 'imagen'">
                          <div class="form-group-sm">
                            <label>URL de imagen</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="comp.contenido.url" (ngModelChange)="guardarConfiguracion()" placeholder="https://...">
                          </div>
                          <div class="form-group-sm">
                            <label>Texto alternativo</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="comp.contenido.alt" (ngModelChange)="guardarConfiguracion()">
                          </div>
                          <div class="form-group-sm">
                            <label>Subir imagen</label>
                            <input type="file" class="form-control form-control-sm" accept="image/*" (change)="onImagenSelected($event, comp)">
                            <small *ngIf="comp.contenido.fileName && !comp.contenido.uploading" class="text-muted">Archivo: {{ comp.contenido.fileName }}</small>
                            <small *ngIf="comp.contenido.uploading" class="text-warning">Subiendo imagen...</small>
                            <small *ngIf="comp.contenido.uploadError" class="text-danger">{{ comp.contenido.uploadError }}</small>
                          </div>
                          <div class="form-group-sm">
                            <label>Ancho</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="comp.estilos.width" (ngModelChange)="guardarConfiguracion()" placeholder="100%">
                          </div>
                          <div class="form-group-sm">
                            <label>Ancho máximo</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="comp.estilos.maxWidth" (ngModelChange)="guardarConfiguracion()" placeholder="100%">
                          </div>
                          <div class="form-group-sm">
                            <label>Alineación</label>
                            <select class="form-control form-control-sm" [(ngModel)]="comp.estilos.textAlign" (ngModelChange)="guardarConfiguracion()">
                              <option value="left">Izquierda</option>
                              <option value="center">Centro</option>
                              <option value="right">Derecha</option>
                            </select>
                          </div>
                          
                          <!-- Bordes -->
                          <div class="form-group-sm" style="border-top: 1px solid #e9ecef; padding-top: 10px; margin-top: 10px;">
                            <label style="font-weight: 600;">Borde</label>
                            <select class="form-control form-control-sm" [(ngModel)]="comp.estilos.borderStyle" (ngModelChange)="guardarConfiguracion()">
                              <option value="none">Sin borde</option>
                              <option value="solid">Sólido</option>
                              <option value="dashed">Discontinuo</option>
                              <option value="dotted">Punteado</option>
                              <option value="double">Doble</option>
                            </select>
                          </div>
                          <div class="form-group-sm" *ngIf="comp.estilos.borderStyle !== 'none'">
                            <label>Ancho</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="comp.estilos.borderWidth" (ngModelChange)="guardarConfiguracion()" placeholder="1px">
                          </div>
                          <div class="form-group-sm" *ngIf="comp.estilos.borderStyle !== 'none'">
                            <label>Color</label>
                            <input type="color" class="form-control form-control-sm" [(ngModel)]="comp.estilos.borderColor" (ngModelChange)="guardarConfiguracion()">
                          </div>
                        </div>

                        <!-- Botón -->
                        <div *ngIf="comp.tipo === 'boton'">
                          <div class="form-group-sm">
                            <label>Texto</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="comp.contenido.texto" (ngModelChange)="guardarConfiguracion()">
                          </div>
                          <div class="form-group-sm">
                            <label>URL</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="comp.contenido.url" (ngModelChange)="guardarConfiguracion()">
                          </div>
                          <div class="form-group-sm">
                            <label>Color de fondo</label>
                            <input type="color" class="form-control form-control-sm" [(ngModel)]="comp.estilos.backgroundColor" (ngModelChange)="guardarConfiguracion()">
                          </div>
                          
                          <!-- Bordes -->
                          <div class="form-group-sm" style="border-top: 1px solid #e9ecef; padding-top: 10px; margin-top: 10px;">
                            <label style="font-weight: 600;">Borde</label>
                            <select class="form-control form-control-sm" [(ngModel)]="comp.estilos.borderStyle" (ngModelChange)="guardarConfiguracion()">
                              <option value="none">Sin borde</option>
                              <option value="solid">Sólido</option>
                              <option value="dashed">Discontinuo</option>
                              <option value="dotted">Punteado</option>
                              <option value="double">Doble</option>
                            </select>
                          </div>
                          <div class="form-group-sm" *ngIf="comp.estilos.borderStyle !== 'none'">
                            <label>Ancho</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="comp.estilos.borderWidth" (ngModelChange)="guardarConfiguracion()" placeholder="1px">
                          </div>
                          <div class="form-group-sm" *ngIf="comp.estilos.borderStyle !== 'none'">
                            <label>Color</label>
                            <input type="color" class="form-control form-control-sm" [(ngModel)]="comp.estilos.borderColor" (ngModelChange)="guardarConfiguracion()">
                          </div>
                        </div>

                        <!-- Espaciador -->
                        <div *ngIf="comp.tipo === 'espaciador'">
                          <div class="form-group-sm">
                            <label>Altura</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="comp.estilos.height" (ngModelChange)="guardarConfiguracion()" placeholder="40px">
                          </div>
                          
                          <!-- Bordes -->
                          <div class="form-group-sm" style="border-top: 1px solid #e9ecef; padding-top: 10px; margin-top: 10px;">
                            <label style="font-weight: 600;">Borde</label>
                            <select class="form-control form-control-sm" [(ngModel)]="comp.estilos.borderStyle" (ngModelChange)="guardarConfiguracion()">
                              <option value="none">Sin borde</option>
                              <option value="solid">Sólido</option>
                              <option value="dashed">Discontinuo</option>
                              <option value="dotted">Punteado</option>
                              <option value="double">Doble</option>
                            </select>
                          </div>
                          <div class="form-group-sm" *ngIf="comp.estilos.borderStyle !== 'none'">
                            <label>Ancho</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="comp.estilos.borderWidth" (ngModelChange)="guardarConfiguracion()" placeholder="1px">
                          </div>
                          <div class="form-group-sm" *ngIf="comp.estilos.borderStyle !== 'none'">
                            <label>Color</label>
                            <input type="color" class="form-control form-control-sm" [(ngModel)]="comp.estilos.borderColor" (ngModelChange)="guardarConfiguracion()">
                          </div>
                        </div>

                        <!-- Contador -->
                        <div *ngIf="comp.tipo === 'contador'">
                          <div class="form-group-sm">
                            <label>Fecha objetivo</label>
                            <input type="datetime-local" class="form-control form-control-sm"
                              [ngModel]="(comp.contenido.targetDate | date:'yyyy-MM-dd\'T\'HH:mm')"
                              (ngModelChange)="onDateTimeChange(comp, $event)">
                          </div>
                          <div class="form-group-sm">
                            <label>Color</label>
                            <input type="color" class="form-control form-control-sm" [(ngModel)]="comp.estilos.color" (ngModelChange)="guardarConfiguracion()">
                          </div>
                          <div class="form-group-sm">
                            <label>Tamaño</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="comp.estilos.fontSize" (ngModelChange)="guardarConfiguracion()" placeholder="24px">
                          </div>
                          
                          <!-- Bordes -->
                          <div class="form-group-sm" style="border-top: 1px solid #e9ecef; padding-top: 10px; margin-top: 10px;">
                            <label style="font-weight: 600;">Borde</label>
                            <select class="form-control form-control-sm" [(ngModel)]="comp.estilos.borderStyle" (ngModelChange)="guardarConfiguracion()">
                              <option value="none">Sin borde</option>
                              <option value="solid">Sólido</option>
                              <option value="dashed">Discontinuo</option>
                              <option value="dotted">Punteado</option>
                              <option value="double">Doble</option>
                            </select>
                          </div>
                          <div class="form-group-sm" *ngIf="comp.estilos.borderStyle !== 'none'">
                            <label>Ancho</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="comp.estilos.borderWidth" (ngModelChange)="guardarConfiguracion()" placeholder="1px">
                          </div>
                          <div class="form-group-sm" *ngIf="comp.estilos.borderStyle !== 'none'">
                            <label>Color</label>
                            <input type="color" class="form-control form-control-sm" [(ngModel)]="comp.estilos.borderColor" (ngModelChange)="guardarConfiguracion()">
                          </div>
                        </div>

                        <!-- Perfil -->
                        <div *ngIf="comp.tipo === 'perfil'">
                          <div class="form-group-sm">
                            <label>Nombre</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="comp.contenido.nombre" (ngModelChange)="guardarConfiguracion()">
                          </div>
                          <div class="form-group-sm">
                            <label>Rol</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="comp.contenido.rol" (ngModelChange)="guardarConfiguracion()">
                          </div>
                          
                          <!-- Bordes -->
                          <div class="form-group-sm" style="border-top: 1px solid #e9ecef; padding-top: 10px; margin-top: 10px;">
                            <label style="font-weight: 600;">Borde</label>
                            <select class="form-control form-control-sm" [(ngModel)]="comp.estilos.borderStyle" (ngModelChange)="guardarConfiguracion()">
                              <option value="none">Sin borde</option>
                              <option value="solid">Sólido</option>
                              <option value="dashed">Discontinuo</option>
                              <option value="dotted">Punteado</option>
                              <option value="double">Doble</option>
                            </select>
                          </div>
                          <div class="form-group-sm" *ngIf="comp.estilos.borderStyle !== 'none'">
                            <label>Ancho</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="comp.estilos.borderWidth" (ngModelChange)="guardarConfiguracion()" placeholder="1px">
                          </div>
                          <div class="form-group-sm" *ngIf="comp.estilos.borderStyle !== 'none'">
                            <label>Color</label>
                            <input type="color" class="form-control form-control-sm" [(ngModel)]="comp.estilos.borderColor" (ngModelChange)="guardarConfiguracion()">
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Propiedades de BANNER -->
          <div *ngIf="componenteSeleccionado.tipo === 'banner'">
            <div class="form-group">
              <label>Título</label>
              <input type="text" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.contenido.titulo"
                     (ngModelChange)="guardarConfiguracion()">
            </div>
            <div class="form-group">
              <label>Subtítulo</label>
              <input type="text" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.contenido.subtitulo"
                     (ngModelChange)="guardarConfiguracion()">
            </div>
            <div class="form-group">
              <label>Imagen de fondo</label>
              <input type="file" 
                     class="form-control" 
                     accept="image/*"
                     (change)="onImagenSelected($event, componenteSeleccionado)">
              <div class="image-preview" *ngIf="componenteSeleccionado.contenido.url" style="margin-top:8px;">
                <img [src]="componenteSeleccionado.contenido.url" alt="Banner" style="max-width:100%; border-radius: 4px; border: 1px solid #dee2e6;">
              </div>
              <small *ngIf="componenteSeleccionado.contenido.fileName && !componenteSeleccionado.contenido.uploading" class="text-muted">Archivo: {{ componenteSeleccionado.contenido.fileName }}</small>
              <small *ngIf="componenteSeleccionado.contenido.uploading" class="text-warning">Subiendo imagen...</small>
              <small *ngIf="componenteSeleccionado.contenido.uploadError" class="text-danger">{{ componenteSeleccionado.contenido.uploadError }}</small>
            </div>
            <div class="form-group">
              <label>Texto del botón</label>
              <input type="text" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.contenido.textoBoton"
                     (ngModelChange)="guardarConfiguracion()">
            </div>
            <div class="form-group">
              <label>URL del botón</label>
              <input type="text" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.contenido.urlBoton"
                     (ngModelChange)="guardarConfiguracion()">
            </div>
            <div class="form-group">
              <label>Color del overlay</label>
              <input type="color" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.estilos.overlayColor"
                     (ngModelChange)="guardarConfiguracion()">
            </div>
            <div class="form-group">
              <label>Color del título</label>
              <input type="color" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.estilos.colorTitulo"
                     (ngModelChange)="guardarConfiguracion()">
            </div>
            <div class="form-group">
              <label>Color del subtítulo</label>
              <input type="color" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.estilos.colorSubtitulo"
                     (ngModelChange)="guardarConfiguracion()">
            </div>
            <div class="form-group">
              <label>Tipografía</label>
              <select class="form-control" 
                      [(ngModel)]="componenteSeleccionado.estilos.fontFamily"
                      (ngModelChange)="guardarConfiguracion()">
                <option *ngFor="let font of tipografiasDisponibles" [value]="font.valor">{{ font.nombre }}</option>
              </select>
            </div>
          </div>

          <!-- Propiedades de DESCUENTO -->
          <div *ngIf="componenteSeleccionado.tipo === 'descuento'">
            <div class="form-group">
              <label>Precio original</label>
              <input type="number" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.contenido.precioOriginal"
                     (ngModelChange)="guardarConfiguracion()">
            </div>
            <div class="form-group">
              <label>Precio con descuento</label>
              <input type="number" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.contenido.precioDescuento"
                     (ngModelChange)="guardarConfiguracion()">
            </div>
            <div class="form-group">
              <label>Moneda</label>
              <input type="text" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.contenido.moneda"
                     (ngModelChange)="guardarConfiguracion()"
                     placeholder="MXN">
            </div>
            <div class="form-group">
              <label>Texto del descuento</label>
              <input type="text" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.contenido.textoDescuento"
                     (ngModelChange)="guardarConfiguracion()"
                     placeholder="¡Descuento especial!">
            </div>
            <div class="form-group">
              <label>
                <input type="checkbox" [(ngModel)]="componenteSeleccionado.contenido.mostrarContador" (ngModelChange)="guardarConfiguracion()">
                Mostrar contador regresivo
              </label>
            </div>
            <div class="form-group" *ngIf="componenteSeleccionado.contenido.mostrarContador">
              <label>Fecha objetivo del contador</label>
              <input type="datetime-local"
                class="form-control"
                [ngModel]="(componenteSeleccionado.contenido.targetDate | date:'yyyy-MM-dd\'T\'HH:mm')"
                (ngModelChange)="onDateTimeChange(componenteSeleccionado, $event)">
            </div>
            <div class="form-group">
              <label>Color de fondo</label>
              <input type="color" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.estilos.backgroundColor"
                     (ngModelChange)="guardarConfiguracion()">
            </div>
            <div class="form-group">
              <label>Color del texto</label>
              <input type="color" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.estilos.colorTexto"
                     (ngModelChange)="guardarConfiguracion()">
            </div>
            <div class="form-group">
              <label>Color del precio original</label>
              <input type="color" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.estilos.colorPrecioOriginal"
                     (ngModelChange)="guardarConfiguracion()">
            </div>
            <div class="form-group">
              <label>Color del precio con descuento</label>
              <input type="color" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.estilos.colorPrecioDescuento"
                     (ngModelChange)="guardarConfiguracion()">
            </div>
            <div class="form-group">
              <label>Padding</label>
              <input type="text" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.estilos.padding"
                     (ngModelChange)="guardarConfiguracion()"
                     placeholder="20px">
            </div>
            <div class="form-group">
              <label>Radio de borde</label>
              <input type="text" 
                     class="form-control" 
                     [(ngModel)]="componenteSeleccionado.estilos.borderRadius"
                     (ngModelChange)="guardarConfiguracion()"
                     placeholder="8px">
            </div>
            <div class="form-group">
              <label>Tipografía</label>
              <select class="form-control" 
                      [(ngModel)]="componenteSeleccionado.estilos.fontFamily"
                      (ngModelChange)="guardarConfiguracion()">
                <option *ngFor="let font of tipografiasDisponibles" [value]="font.value">{{ font.label }}</option>
              </select>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</div>